import React from "react";
import StyledVideo from "./StyledVideo";

export default function Video({ recipe }) {
  return (
    <li className="video featured">
      <a
        href={`https://www.youtube.com/watch?v=${recipe.youTubeId}`}
        className="featured-video"
      >
        <StyledVideo thumbnail={recipe.thumbnail}>
          <img
            src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/50598/video-thumb-placeholder-16-9.png"
            alt=""
          />
          <figcaption>
            {recipe.title.length > 30
              ? `${recipe.title.split(" ").splice(0, 5).join(" ")}...`
              : recipe.title}
          </figcaption>
        </StyledVideo>
      </a>
    </li>
  );
}
